import Calendar from './calendar/et_EE';
import DatePicker from './date-picker/et_EE';
import Pagination from './pagination/et_EE';
import TimePicker from './time-picker/et_EE';

export default {
  locale: 'et',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Filtri menÃ¼Ã¼',
    filterConfirm: 'OK',
    filterReset: 'Nulli',
    selectAll: 'Vali kÃµik',
    selectInvert: 'Inverteeri valik',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'TÃ¼hista',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'TÃ¼hista',
  },
  Transfer: {
    searchPlaceholder: 'Otsi siit',
    itemUnit: 'kogus',
    itemsUnit: 'kogus',
  },
  Upload: {
    uploading: 'Ãleslaadimine...',
    removeFile: 'Eemalda fail',
    uploadError: 'Ãleslaadimise tÃµrge',
    previewFile: 'Faili eelvaade',
  },
  Empty: {
    description: 'Andmed puuduvad',
  },
};
